import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Field, reduxForm } from "redux-form";
import successIcon from "../../assets/images/success2.png";

class ResetPasswordModal extends Component {
  render() {
    const closeBtn = (
      <button className="close p-3" onClick={this.props.toggle}>
        &times;
      </button>
    );
    return (
      <div>
        <Modal isOpen={this.props.modal} className={this.props.className}>
          <ModalHeader toggle={this.props.toggle} close={closeBtn} className=" pb-0">
            <center> Reset Password</center>
          </ModalHeader>
          <ModalBody>
            <div className="modal-success-part text-center">
              <div className="success-icon">
                <img src={successIcon} alt="" width="120px" />
              </div>
              <b>
                <h1>Success</h1>
              </b>
              <div className="sub-text">
                <p>
                  We have sent you an email on your registered email address.
                  <br />
                  Please access the link appended in the email to reset the password.
                </p>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default ResetPasswordModal;



// WEBPACK FOOTER //
// ./components/ResetPasswordModal/index.js